import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';

// Configuración de recursos (diccionarios)
const resources = {
  es: {
    translation: esTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n
  // Detecta el idioma del usuario según el navegador o localStorage
  .use(LanguageDetector)
  // Pasa la instancia de i18n a react-i18next
  .use(initReactI18next)
  .init({
    resources,
    // Eliminamos el lng forzado para que el detector automático haga su magia
    // lng: 'es', // idioma por defecto (si no funciona la detección)
    fallbackLng: 'es', // Si falla la traducción, siempre vuelve a Español (Muro de carga)
    
    // Opciones para la interpolación (react gestiona el XSS de forma segura)
    interpolation: {
      escapeValue: false, 
    },
    
    // Ajustes del detector de idioma
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], // Guarda la preferencia detectada localmente
      lookupLocalStorage: 'aura_user_language', // Nombre de la clave en memoria
    }
  });

export default i18n;
